export default __webpack_public_path__ + "static/Hero-a2b52ccd52f7983c155b32654bbdd12b.png";